import React from 'react';
import { Link } from 'react-router-dom';
import { BlogListContainer, BlogCard } from './Blog.style';
import { useTranslation } from 'react-i18next';

const blogs = [
  {
    title: 'FindJobs',
    description: 'DescOne',
    link: '/blog/find-jobs-online-easily-with-wafynet',
  },
  {
    title: 'GrowNetwork',
    description: 'DescTwo',
    link: '/blog/grow-your-professional-network-online',
  },
  {
    title: 'Promote',
    description: 'DescThree',
    link: '/blog/promote-your-business-online',
  },
];

export default function BlogHome() {
  const { t } = useTranslation();

  return (
    <BlogListContainer>
      {blogs.map((blog, index) => (
        <BlogCard key={index}>
          <h2>{t(`Blog.${blog.title}`)}</h2>
          <p>{t(`Blog.${blog.description}`)}</p>
          <Link to={blog.link} className="read-more-btn">
            {t('Blog.ReadMore')}
          </Link>
        </BlogCard>
      ))}
    </BlogListContainer>
  );
}
